const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px 120px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    let cachedTop = 0;
    let cachedHeight = 0;

    function measure() {
      const rect = element.getBoundingClientRect();
      cachedTop = rect.top + window.scrollY;
      cachedHeight = element.offsetHeight || rect.height;
    }

    measure();
    window.addEventListener('resize', measure, { passive: true });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
        if (elementIsVisible) {
          measure();
        }
      });
    });
    observer.observe(element);

    function updateRatio() {
      const viewportHeight = window.innerHeight;
      const scrollY = window.scrollY;
      if (cachedTop > scrollY + viewportHeight) {
        element.style.setProperty('--zoom-in-ratio', 1);
        return;
      } else if (cachedTop + cachedHeight < scrollY) {
        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * 100);
        return;
      }
      const distance = scrollY + viewportHeight - cachedTop;
      const percentage = Math.round(distance / ((viewportHeight + cachedHeight) / 100));
      element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentage);
    }

    updateRatio();

    const scrollHandler = typeof throttle === 'function'
      ? throttle(() => {
          if (!elementIsVisible) return;
          updateRatio();
        })
      : () => {
          if (!elementIsVisible) return;
          updateRatio();
        };

    window.addEventListener('scroll', scrollHandler, { passive: true });
  });
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
